import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    salaryList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    salaryDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
    employeeSalaryList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    employeeSalaryDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const salarySlice = createSlice({
  name: 'salary',
  initialState,
  reducers: {
    getSalaryList: (state, action) => {
        state.salaryList.requesting = true;
        state.salaryList.error = null;
        state.salaryList.items = [];
        state.salaryList.success = false;
        state.salaryList.filters = action.payload;
    },
    getSalaryListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.salaryList.requesting = false;        
        state.salaryList.items = data;
        state.salaryList.success = true; 
        state.salaryList.pagination.current_page = current_page;
        state.salaryList.pagination.per_page = per_page;
        state.salaryList.pagination.total = total;
    },
    getSalaryListFail: (state, action) => {        
        state.salaryList.requesting = false;
        state.salaryList.error = action.payload;
    },
    getSalaryDetails: (state) => {
        state.salaryDetails.requesting = true;
        state.salaryDetails.error = null;
        state.salaryDetails.data = null;
        state.salaryDetails.success = false; 
    },
    getSalaryDetailsSuccess: (state, action) => {
        state.salaryDetails.requesting = false;
        state.salaryDetails.data = action.payload;
        state.salaryDetails.success = true; 
    },
    getSalaryDetailsFail: (state, action) => {        
        state.salaryDetails.requesting = false;
        state.salaryDetails.error = action.payload;
    },

    doSalaryCreate: (state) => {
        state.salaryDetails.requesting = true;
        state.salaryDetails.error = null;
        state.salaryDetails.data = null;
        state.salaryDetails.success = false; 
    },

    doSalaryUpdate: (state) => {
        state.salaryDetails.requesting = true;
        state.salaryDetails.error = null;
        state.salaryDetails.data = null;
        state.salaryDetails.success = false; 
    },
    doSalaryDelete: (state) => {
        state.salaryDetails.requesting = true;
        state.salaryDetails.error = null;
        state.salaryDetails.data = null;
        state.salaryDetails.success = false; 
    },
    //
    getEmployeeSalaryList: (state, action) => {
        state.employeeSalaryList.requesting = true;
        state.employeeSalaryList.error = null;
        state.employeeSalaryList.items = [];
        state.employeeSalaryList.success = false;
        state.employeeSalaryList.filters = action.payload;
    },
    getEmployeeSalaryListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.employeeSalaryList.requesting = false;        
        state.employeeSalaryList.items = data;
        state.employeeSalaryList.success = true; 
        state.employeeSalaryList.pagination.current_page = current_page;
        state.employeeSalaryList.pagination.per_page = per_page;
        state.employeeSalaryList.pagination.total = total;
    },
    getEmployeeSalaryListFail: (state, action) => {        
        state.employeeSalaryList.requesting = false;
        state.employeeSalaryList.error = action.payload;
    },
    getEmployeeSalaryDetails: (state) => {
        state.employeeSalaryDetails.requesting = true;
        state.employeeSalaryDetails.error = null;
        state.employeeSalaryDetails.data = null;
        state.employeeSalaryDetails.success = false; 
    },
    getEmployeeSalaryDetailsSuccess: (state, action) => {
        state.employeeSalaryDetails.requesting = false;
        state.employeeSalaryDetails.data = action.payload;
        state.employeeSalaryDetails.success = true; 
    },
    getEmployeeSalaryDetailsFail: (state, action) => {        
        state.employeeSalaryDetails.requesting = false;
        state.employeeSalaryDetails.error = action.payload;
    },

    doEmployeeSalaryCreate: (state) => {
        state.employeeSalaryDetails.requesting = true;
        state.employeeSalaryDetails.error = null;
        state.employeeSalaryDetails.data = null;
        state.employeeSalaryDetails.success = false; 
    },

    doEmployeeSalaryUpdate: (state) => {
        state.employeeSalaryDetails.requesting = true;
        state.employeeSalaryDetails.error = null;
        state.employeeSalaryDetails.data = null;
        state.employeeSalaryDetails.success = false; 
    },
    doEmployeeSalaryDelete: (state) => {
        state.employeeSalaryDetails.requesting = true;
        state.employeeSalaryDetails.error = null;
        state.employeeSalaryDetails.data = null;
        state.employeeSalaryDetails.success = false; 
    },
  },
})

export const { 
    getSalaryList, getSalaryListSuccess, getSalaryListFail,
    getSalaryDetails, getSalaryDetailsSuccess, getSalaryDetailsFail,
    doSalaryCreate, doSalaryUpdate, doSalaryDelete,
    getEmployeeSalaryList, getEmployeeSalaryListSuccess, getEmployeeSalaryListFail,
    getEmployeeSalaryDetails, getEmployeeSalaryDetailsSuccess, getEmployeeSalaryDetailsFail,
    doEmployeeSalaryCreate, doEmployeeSalaryUpdate, doEmployeeSalaryDelete,
} = salarySlice.actions

export default salarySlice.reducer